export default "__VITE_ASSET__BE3TIao0__"